import { CommonModule } from '@angular/common';
import { Component, Injectable, OnInit, forwardRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  AlertController,
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NoticiaAudiosPage } from 'src/app/components/noticia-audios/noticia-audios.page';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { ImagePipe } from 'src/app/pipes/image/image';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html/safe-html';
import { MensagemProvider } from 'src/app/services/mensagem/mensagem';
import { Browser } from '@capacitor/browser';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { environment } from 'src/environments/environment';

declare var instituicaoConstants: { IS_PWA: boolean };
@Component({
  selector: 'app-mensagem-detail',
  templateUrl: './mensagem-detail.page.html',
  styleUrls: ['./mensagem-detail.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    ImagePipe,
    LoadingSpinnerComponent
  ],
})
export class MensagemDetailPage implements OnInit {
  playVideo = false;
  playingVideo = false;
  mensagem: any = { criador: {} };
  isPWA = false;
  loaded = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public msgProvider: MensagemProvider,
    public modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.msgProvider
      .getMensagem(this.navParams.get('id'))
      .subscribe((res: { mensagem: any }) => {
        this.mensagem = res.mensagem;
        this.isPWA = instituicaoConstants.IS_PWA;
        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      });
  }

  async delete(msg: { id: any }) {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant('Confirmar exclusão'),
      buttons: [
        {
          text: this.translate.instant('Cancelar'),
          role: 'cancel',
        },
        {
          text: this.translate.instant('Excluir'),
          cssClass: 'danger',
          handler: () => {
            this.msgProvider.excluir([msg.id]).subscribe((res: any) => {
              this.closeModal(msg.id);
            });
          },
        },
      ],
    });
    alert.present();
  }

  public closeModal(close: any) {
    this.modalCtrl.dismiss(close);
  }

  async openAudios() {
    this.playVideo = false;
    this.playingVideo = false;
    var data = {
      audios: this.mensagem.audios,
    };
    const modalPage = await this.modalCtrl.create({
      component: NoticiaAudiosPage,
      componentProps: data,
    });
    modalPage.present();
  }

  public openLink(link: { target: string; url: string }, entidade: any) {
    if (entidade === 'sacerdotal' && environment.isMessianica) {
      Browser.open({ url: environment.URL_EXAME_SACERDOTAL + 'exame-sacerdotal/perfil-candidato?token=' + link.url });
    }

    Browser.open({ url: link.url });
  }

  public disponiveis() {
    // this.modalCtrl.create('SoreiSaishiNotificationPage').present();
  }

}
